module.exports = __webpack_public_path__ + "static/media/sidebar_logo.28fe3829.png";